import { render, staticRenderFns } from "./ProgrammeEntry.vue?vue&type=template&id=395fbba6&lang=pug&"
import script from "./ProgrammeEntry.vue?vue&type=script&lang=js&"
export * from "./ProgrammeEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports